import { IContentStatus } from "../common";

export const contentConstants: IContentStatus = {
  GET_CONTENT_REQUEST: "GET_CONTENT_REQUEST",
  GET_CONTENT_SUCCESS: "GET_CONTENT_SUCCESS",
  GET_CONTENT_FAILURE: "GET_CONTENT_FAILURE"
};